import React from "react";

const NotFound = () => {
  return (
    <div className="p-32 min-h-screen min-w-full  flex justify-center items-center">
      <p className="text-primary text-xl font-[Manrope] font-semibold">
        PAGE NOT FOUND
      </p>
    </div>
  );
};

export default NotFound;

// Developed By
// Md.Shefat Zeon
// 2023-05-23
